import util from '@bmp-vue/core/api/util'

const controller = 'OperadorOnboardingAssociado'
export default Object.assign({}, util.GetCrud(controller, null), {
    EnviarEmailPrimeiroAcesso: function (dto) {
        return util.Axios.Post(controller + '/EmailPrimeiroAcesso', dto)
    },
})